import React, { useState, useEffect } from "react";
import bookingService from "app/services/bookingService";

import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Breadcrumb, SimpleCard } from "@gull";
import { AiFillFileExcel } from "react-icons/ai";

import { MdRefresh, MdSearch } from "react-icons/md";
import DatePicker from "react-datepicker";
import BootstrapTable from "react-bootstrap-table-next";
import queryStringService from "app/services/queryStringService";
import paginationFactory from "react-bootstrap-table2-paginator";
import moment from "moment";

import SearchService from "app/services/SearchService";
import Tooltip from "rc-tooltip";
import overlayFactory from "react-bootstrap-table2-overlay";
import {
  Row,
  Col,
  DropdownButton,
  Dropdown,
  Spinner,
  Accordion,
  Card,
} from "react-bootstrap";

import config from "config.json";
import { Button } from "react-bootstrap";
import { Formik } from "formik";

import * as Yup from "yup";
import {
  getTransactionByApiUser,
  exportLedgerByApiUser,
} from "app/services/MasterAdmin & ApiUSer/apiPartnerService";

const validationSchema = Yup.object().shape({
  memId: Yup.number().required("Please select member"),
  transactionAmount: Yup.number().required("Please enter Transaction Amount"),
  transactionType: Yup.string().required("Please select credit type"),
});

const { apiUrl, dateTimeFormat, dateFormat } = config;

function TransactionHistory() {
  const [state, setState] = useState({
    page: 1,
    data: [],
    sizePerPage: 10,
    dataCount: 0,
    loading: true,
    FromDate: "",
    ToDate: "",
    TransactionMode: "",
  });

  const dateFormater = (cell, row) => {
    return moment(cell).format(dateTimeFormat);
  };
  const ledgerFormatter = (cell, row) => {
    return moment(row.ladgerDate).format(dateTimeFormat);
  };
  const transactionModeFormatter = (cell, row) => {
    // console.log(row);

    if (row.transactionMode == "Debit") {
      return (
        <div>
          <span className="text-danger">Debit</span>{" "}
          <img
            src="/assets/images/debit 1.png"
            alt=""
            width={40}
            height={30}
            className="p-0 m-0"
          />
        </div>
      );
    } else {
      return (
        <div>
          <span className="text-success">Credit</span>
          <img
            src="/assets/images/credit 1.png"
            alt=""
            width={40}
            height={30}
            className="p-0 m-0"
          />
        </div>
      );
    }
  };
  const transactionAmountFormatter = (cell, row) => {
    return <span> ₹ {row.transactionAmount} </span>;
  };
  const leadgerBalanceFormatter = (cell, row) => {
    return <span> ₹ {row.leadgerBalance} </span>;
  };
  const openingFormatter = (cell, row) => {
    return <span> ₹ {row.opening} </span>;
  };
  const closingFormatter = (cell, row) => {
    return <span> ₹ {row.closing} </span>;
  };
  const remarksFormatter = (cell, row) => {
    return (
      <Tooltip
        placement="top"
        overlay={<div style={{ maxWidth: 250 }}>{row.narration}</div>}
      >
        <span>{row.narration.substring(0, 10)}...</span>
      </Tooltip>
    );
  };

  const creditFormatter = (cell, row) => {
    if (row.creditBalance == 0 || row.creditBalance == null) {
      return <span> ₹ 0 </span>;
    } else {
      return <span> ₹ {row.creditBalance} </span>;
    }
  };

  const columns = [
    {
      dataField: "sln",
      text: "Txn Id",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center", width: "100px" };
      },
    },
    {
      dataField: "member.uniqueIdentity",
      text: "User Name",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center", width: "100px" };
      },
    },
    // {
    //   dataField: "member.company",
    //   text: "Company",
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "200px", textAlign: "center" };
    //   },
    // },
    {
      dataField: "transactionDate",
      text: "Txn Date",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: dateFormater,
    },
    {
      dataField: "ladgerDate",
      text: "Approval Date",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: ledgerFormatter,
    },
    {
      dataField: "refNo",
      text: "Ref No",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "correlationId",
      text: "Correlation Id",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "transactionType",
      text: "Txn Type",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "transactionAmount",
      text: "Txn Amount",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: transactionAmountFormatter,
    },
    {
      dataField: "transactionMode",
      text: "Txn Mode",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: transactionModeFormatter,
    },
    {
      dataField: "opening",
      text: "Opening",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: openingFormatter,
    },
    {
      dataField: "closing",
      text: "Closing",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: closingFormatter,
    },
    {
      dataField: "creditBalance",
      text: "Credit Balance",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: creditFormatter,
    },
    {
      dataField: "leadgerBalance",
      text: "Ledger Balance",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: leadgerBalanceFormatter,
    },

    {
      dataField: "narration",
      text: "Remarks",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: remarksFormatter,
    },
  ];
  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };
  const NoDataIndication = () => {
    const { loading } = state;
    //alert(loading);
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadTransactionLog = async () => {
    const { page, sizePerPage, FromDate, ToDate, TransactionMode, ApiUserId } =
      state;
    const query = queryStringService.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      FromDate,
      ToDate,
      TransactionMode,
      ApiUserId,
    });
    if (state.dataCount !== 0) {
      setState((prev) => ({ ...prev, loading: true }));
    }
    const response = await getTransactionByApiUser(query);

    const data = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);
    // console.log(paggingData);
    setState((prev) => ({
      ...prev,
      loading: false,
      data,
      dataCount: paggingData.TotalCount,
      page: paggingData.CurrentPage,
      sizePerPage: paggingData.PageSize,
    }));
  };

  useEffect(() => {
    loadTransactionLog();
  }, [state.page, state.sizePerPage]);

  const handleTableChange = async (type, { page, sizePerPage }) => {
    const currentIndex = (page - 1) * sizePerPage;
    setState((prev) => ({ ...prev, page, sizePerPage }));
    setTimeout(async () => {
      await loadTransactionLog();
    }, 10);
  };

  const handleSearch = async () => {
    setState((prev) => ({ ...prev, page: 1, sizePerPage: 10 }));

    setTimeout(async () => {
      await loadTransactionLog();
    }, 10);
  };

  const handleExport = async () => {
    setState((prev) => ({ ...prev, page: 1, sizePerPage: 10 }));

    setTimeout(async () => {
      await exportAllLedger();
    }, 10);
  };
  const exportAllLedger = async () => {
    const { page, sizePerPage, FromDate, ToDate, TransactionMode } = state;
    const query = queryStringService.getQueryStringFromObj({
      FromDate,
      ToDate,
      TransactionMode,
    });
    if (state.dataCount !== 0) {
      setState((prev) => ({ ...prev, loading: true }));
    }

    const response = await exportLedgerByApiUser(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${moment().toISOString()}_ladger.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setState((prev) => ({ ...prev, loading: false }));
  };
  const handleSearchChanges = (e) => {
    setState((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setTimeout(async () => {
      await loadTransactionLog();
    }, 10);
  };
  const refreshFilter = async (e) => {
    setState((prev) => ({
      ...prev,
      FromDate: "",
      ToDate: "",
      TransactionMode: "",
    }));
    setTimeout(async () => {
      await loadTransactionLog();
    }, 10);
  };

  const { data, sizePerPage, page, dataCount, loading } = state;

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary h-75" : "btn-light h-75"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };
  return (
    <>
      <div>
        <Helmet>
          <title>Transaction History</title>
        </Helmet>
        <Breadcrumb
          routeSegments={[{ name: "Transaction History" }]}
        ></Breadcrumb>

        <div className="card card-body text-left " id="transactionHistory">
          <div className="card-body">
            <div className=" mx-auto">
              <div className="row ">
                <div className="col-md-3 col-12">
                  <div className="form-group">
                    <label> Date From</label>
                  </div>
                  <input
                    type="date"
                    className="form-control"
                    name="FromDate"
                    value={state.FromDate}
                    onChange={handleSearchChanges}
                    max={moment().format("YYYY-MM-DD")}
                  />
                </div>
                <div className="col-md-3 col-12">
                  <div className="form-group">
                    <label> Date To</label>
                  </div>
                  <input
                    type="date"
                    className="form-control"
                    name="ToDate"
                    value={state.ToDate}
                    onChange={handleSearchChanges}
                    max={moment().format("YYYY-MM-DD")}
                  />
                </div>
                <div className="col-md-3 col-12">
                  <div className="form-group">
                    <label> Search Text</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    name="SearchType"
                    value={state.SearchType}
                    onChange={handleSearchChanges}
                  />
                </div>
                <div
                  className="col d-flex justify-content-center mb-3"
                  style={{ marginTop: "3%" }}
                >
                  <button
                    className="btn btn-outline-primary"
                    onClick={handleSearch}
                  >
                    <MdSearch className="" size={18} />
                  </button>
                  <button
                    className="btn btn-primary mx-2"
                    onClick={refreshFilter}
                  >
                    Refresh
                  </button>
                  <Button
                    variant="outline-primary"
                    onClick={handleExport}
                    disabled={!dataCount}
                  >
                    Export
                    <AiFillFileExcel className="ms-1" />
                  </Button>
                </div>
              </div>
            </div>
            {/* <div className=" mx-auto">
              <div className="bookingList-header mb-3">
                <div className="row ml-2 ">
                  <div className="col-md-3 col-12">
                   
                    <input
                      type="date"
                      className="form-control"
                      name="FromDate"
                      value={state.FromDate}
                      onChange={handleSearchChanges}
                      max={moment().format("YYYY-MM-DD")}
                    />
                  </div>
                  <div className="col-md-3 col-12">
                    <input
                      type="date"
                      className="form-control"
                      name="ToDate"
                      value={state.ToDate}
                      onChange={handleSearchChanges}
                      max={moment().format("YYYY-MM-DD")}
                    />
                  </div>
                  <div className="col-md-2 col-12">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control"
                      name="TransactionMode"
                      value={state.TransactionMode}
                      onChange={handleSearchChanges}
                    />
                  </div>
                  <div
                    className="col-4 d-flex justify-content-end mb-3"
                  >
                    <button
                      className="btn btn-outline-primary"
                      onClick={handleSearch}
                    >
                      <MdSearch className="" size={18} />
                    </button>
                    <button
                      className="btn btn-primary mx-2"
                      onClick={refreshFilter}
                    >
                      Refresh
                    </button>
                    <Button
                      variant="outline-primary"
                      onClick={handleExport}
                    >
                      Export Excel
                      <AiFillFileExcel className="" />
                    </Button>
                  </div>
                </div>
              </div>
            </div> */}

            <BootstrapTable
              hover
              remote
              keyField="sln"
              data={data}
              columns={columns}
              pagination={paginationFactory(paginationOptions)}
              onTableChange={handleTableChange}
              noDataIndication={() => <NoDataIndication />}
              loading={loading}
              overlay={overlayFactory({
                spinner: true,
                styles: {
                  overlay: (base) => ({
                    ...base,
                    background: "rgba(120, 120, 120, 0.5)",
                    zIndex: "1",
                  }),
                },
              })}
              headerClasses="bg-primary text-white"
              bodyClasses="react-bootstrap-table-next-min-height"
              rowStyle={rowStyle}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default TransactionHistory;
